import {
    FaBell, FaBook, FaBus, FaCalendarAlt, FaCamera, FaCheckCircle,
    FaChild, FaClipboardList, FaDesktop, FaExclamationTriangle, FaFileAlt,
    FaFirstAid, FaLaptop, FaPrint, FaQuestionCircle, FaSchool, FaShieldAlt,
    FaTools, FaUser, FaUserCheck, FaUsers, FaUtensils, FaVideo, FaWrench,
} from 'react-icons/fa';

/** Curated solid icons that match the established School Engine module style. */
export const FORM_ICON_OPTIONS = [
    { library: 'fa', name: 'FaClipboardList', label: 'Form', component: FaClipboardList },
    { library: 'fa', name: 'FaFileAlt', label: 'Document', component: FaFileAlt },
    { library: 'fa', name: 'FaUser', label: 'Person', component: FaUser },
    { library: 'fa', name: 'FaUsers', label: 'People', component: FaUsers },
    { library: 'fa', name: 'FaUserCheck', label: 'Approved person', component: FaUserCheck },
    { library: 'fa', name: 'FaChild', label: 'Learner', component: FaChild },
    { library: 'fa', name: 'FaCamera', label: 'Camera', component: FaCamera },
    { library: 'fa', name: 'FaVideo', label: 'CCTV', component: FaVideo },
    { library: 'fa', name: 'FaTools', label: 'Tools', component: FaTools },
    { library: 'fa', name: 'FaWrench', label: 'Maintenance', component: FaWrench },
    { library: 'fa', name: 'FaLaptop', label: 'Laptop', component: FaLaptop },
    { library: 'fa', name: 'FaDesktop', label: 'Computer', component: FaDesktop },
    { library: 'fa', name: 'FaPrint', label: 'Printing', component: FaPrint },
    { library: 'fa', name: 'FaCalendarAlt', label: 'Calendar', component: FaCalendarAlt },
    { library: 'fa', name: 'FaBell', label: 'Alert', component: FaBell },
    { library: 'fa', name: 'FaExclamationTriangle', label: 'Warning', component: FaExclamationTriangle },
    { library: 'fa', name: 'FaCheckCircle', label: 'Completed', component: FaCheckCircle },
    { library: 'fa', name: 'FaQuestionCircle', label: 'Question', component: FaQuestionCircle },
    { library: 'fa', name: 'FaShieldAlt', label: 'Safeguarding', component: FaShieldAlt },
    { library: 'fa', name: 'FaFirstAid', label: 'First aid', component: FaFirstAid },
    { library: 'fa', name: 'FaSchool', label: 'School', component: FaSchool },
    { library: 'fa', name: 'FaBook', label: 'Learning', component: FaBook },
    { library: 'fa', name: 'FaBus', label: 'Transport', component: FaBus },
    { library: 'fa', name: 'FaUtensils', label: 'Catering', component: FaUtensils },
];

/** Returns a safe icon component, falling back to the standard form icon. */
export function getFormIcon(icon) {
    return FORM_ICON_OPTIONS.find((option) => option.library === icon?.library && option.name === icon?.name)?.component || FaClipboardList;
}
